import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
  useTheme
} from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { buySearchCreditTexts } from 'src/common/config/TextMessage';
import CloseIcon from '@mui/icons-material/Close';
import { buySearchCreditModalSxs } from './keywordResearchCSS';
import { API } from 'src/common/config/API';
import { RootState } from 'src/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import CommonAlert from 'src/common/CommonAlert';
import { buyAddon, getCreditDetails } from 'src/common/Scraper';
import { setSelectedSearches } from 'src/redux/keywordResearch';
import { setLocationListResponse } from 'src/redux/localSeo';
import { updateSearchesDetailsAndLimits } from 'src/common/config/FunctionHelperPartTwo';

export const BuySearchCreditModal = ({
  handleCloseCreditModal,
  handleCloseProcessCreditModal,
  setOpenCreditProcessModal,
  setIsError = null,
  isLocalSeo = null,
  handleCloseBuySlotsCommonModal = () => {},
  setSnackBarData = (value) => {}
}) => {
  const [creditData, setCreditData] = useState([]);
  const [btnLoader, setBtnLoader] = useState(null);
  const [alertData, setAlertData]: any = useState(null);
  const [loadingButtonIndex, setLoadingButtonIndex] = useState(null);
  const userEmail = useSelector((state: RootState) => state.counter.userEmail);
  const theme = useTheme(); // Access the theme
  const dispatch = useDispatch();
  const styles = buySearchCreditModalSxs(theme);
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  const locationListResponse =
    useSelector((state: RootState) => state.localSeo.locationListResponse) ??
    false;
  const isMember = userDetails?.role_type === 'member';
  useEffect(() => {
    getAddon();
  }, []);

  // Hit the get-credit-details api
  const getCreditDetailApi = async () => {
    let getSearchesDetail = await getCreditDetails();
    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
  };

  const getAddon = async () => {
    try {
      await API.getAddon(
        API.EndPoint.getAddon + (isLocalSeo ? `?type=localaddon` : ''),
        API.Method.get,
        undefined,
        {},
        (response) => {
          if (response?.data?.status === 'success') {
            let plans = response?.data?.plans || [];

            // Filter by selected interval if local SEO
            if (isLocalSeo) {
              plans = plans?.filter(
                (plan) =>
                  plan?.metadata?.type === 'localaddon' &&
                  plan?.metadata?.interval ===
                    stripeSubscriptionDetails?.interval + 'ly'
              );
            }

            setCreditData(plans);
          }
        }
      );
    } catch (err) {}
  };

  const buyAddOnClick = async (planId: string, credit: string) => {
    try {
      handleCloseCreditModal();
      setOpenCreditProcessModal(true);
      setAlertData({
        status: 'info',
        message: buySearchCreditTexts?.infoMessage
      });

      let response: any = await buyAddon({
        email: userEmail,
        planId: planId
      });
      if (response?.status == 'success') {
        if (response?.redirectUrl) {
          window.location.href = response?.redirectUrl;
        }
        if (isLocalSeo) {
          dispatch(
            setLocationListResponse({
              ...locationListResponse,
              limitExceeded: response?.limitExceeded
            })
          );

          setSnackBarData(response);
        }
        getCreditDetailApi();
        setLoadingButtonIndex(null);
        dispatch(setSelectedSearches(credit));
      }
      if (response?.status == 'error') {
        setIsError(response?.message);
      }
      handleCloseProcessCreditModal();
    } catch (err) {
      handleCloseProcessCreditModal();
    }
  };

  const sortedCreditData =
    isLocalSeo && creditData
      ? [...creditData]?.sort((a, b) => a.unit_amount - b.unit_amount)
      : creditData
      ? creditData
      : [];

  return (
    <Fragment>
      <Box sx={{ ...styles?.headerBoxSx, ...styles?.paddingSx }}>
        <Typography sx={styles?.headerTitleSx}>
          {isLocalSeo
            ? buySearchCreditTexts?.modalTitleLocalSeo
            : buySearchCreditTexts?.modalTitle}
        </Typography>
        <IconButton
          aria-label="close"
          className="hover:rounded-lg"
          sx={styles?.headerIconBtnSx}
          onClick={() => {
            if (isLocalSeo) {
              handleCloseBuySlotsCommonModal();
            } else {
              handleCloseCreditModal();
            }
          }}
        >
          <CloseIcon sx={styles?.closeIcon} />
        </IconButton>
      </Box>
      <Box sx={styles?.paddingSx}>
        <Typography
          sx={{ ...styles?.descSx, maxWidth: isLocalSeo ? '800px' : 'none' }}
        >
          {isLocalSeo
            ? buySearchCreditTexts?.descLocalSeo
            : buySearchCreditTexts?.desc}
        </Typography>
        <Box sx={styles?.cardBoxSx}>
          <Grid container spacing={2}>
            {creditData?.length == 0 || !creditData ? (
              <Box sx={styles?.loaderBox}>
                <CircularProgress sx={styles?.loaderSx} />
              </Box>
            ) : (
              sortedCreditData?.map((item, index) => (
                <Grid
                  sx={index == 0 ? styles?.subGridSx : {}}
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  key={index}
                >
                  <Card
                    sx={{
                      ...styles?.cardSx,
                      backgroundColor: index == 2 ? 'var(--color-primary)' : '',
                      position: index == 2 ? 'relative' : '',
                      overflow: 'visible'
                    }}
                  >
                    <CardContent sx={styles?.cardContentSx}>
                      {index == 2 && (
                        <Chip
                          label={
                            <Typography sx={styles?.chipTextSx}>
                              {buySearchCreditTexts?.bestValue}
                            </Typography>
                          }
                          sx={styles?.bestValueChip}
                        />
                      )}
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          justifyContent: 'space-between',
                          width: '100%',
                          minWidth: 'max-content'
                        }}
                      >
                        <Typography
                          sx={{
                            ...styles?.priceTextSx,
                            color:
                              index == 2
                                ? 'var(--color-border-muted)'
                                : 'var(--color-text-tertiary)'
                          }}
                        >
                          {'$'}
                          {isLocalSeo &&
                          stripeSubscriptionDetails?.interval == 'year'
                            ? `${(item?.unit_amount / 12 / 100).toFixed(2)}/mo`
                            : `${item?.unit_amount / 100 || 0}/mo`}{' '}
                          {isLocalSeo &&
                            stripeSubscriptionDetails?.interval == 'year' && (
                              <span style={{ fontSize: '12px' }}>
                                {'(billed annually)'}
                              </span>
                            )}
                          {!isLocalSeo && buySearchCreditTexts?.oneTime}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          ...styles?.creditTextSx,
                          color:
                            index == 2
                              ? 'var(--color-white)'
                              : 'var(--color-primary)'
                        }}
                      >
                        <span style={styles?.spanStyle}>
                          {item?.metadata?.credit}
                        </span>
                        {isLocalSeo
                          ? buySearchCreditTexts?.slot
                          : buySearchCreditTexts?.searchCredit}
                      </Typography>
                      <Button
                        fullWidth
                        variant="contained"
                        sx={{
                          ...styles?.btnSx,
                          backgroundColor:
                            index == 2 ? 'var(--color-white)' : '',
                          color: index == 2 ? 'var(--color-primary)' : '',
                          '&:hover': {
                            backgroundColor:
                              index == 2 ? 'rgba(246, 243, 255, 0.8)' : ''
                          },
                          '&.Mui-disabled': {
                            backgroundColor:
                              index == 2 ? 'var(--color-white)' : ''
                          }
                        }}
                        onClick={() => {
                          if (isMember) {
                            return;
                          }
                          setLoadingButtonIndex(index);
                          buyAddOnClick(item?.id, item?.metadata?.credit);
                        }}
                        disabled={
                          (loadingButtonIndex !== index && btnLoader) ||
                          isMember
                        }
                      >
                        {loadingButtonIndex == index && btnLoader ? (
                          <CircularProgress
                            size={27}
                            sx={{
                              color:
                                index !== 2
                                  ? 'var(--color-white)'
                                  : 'var(--color-primary)'
                            }}
                          />
                        ) : (
                          buySearchCreditTexts?.purchase
                        )}
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </Box>
      </Box>
      <Box sx={{ ...styles?.paddingSx, ...styles?.alertBoxSx }}>
        {alertData?.status && (
          <CommonAlert
            severity={alertData?.status}
            message={alertData?.message}
          />
        )}
      </Box>
      <Box
        sx={{
          ...styles?.mainFooterSx,
          ...styles?.footerPaddingSx
        }}
      >
        {/* Google Reviews Box */}
        <Box sx={styles?.containerBox}>
          <Box>
            <img
              src={process.env.PUBLIC_URL + `/static/images/icons/google.svg`}
              alt="icon"
            />
          </Box>
          <Box>
            <img
              src={process.env.PUBLIC_URL + `/static/images/icons/stars.svg`}
              alt="icon"
            />
          </Box>
          <Typography sx={styles?.footerTypoSx}>{'4.9 rating'}</Typography>
        </Box>
        {/* Rating Box */}
        <Box sx={styles?.containerBox}>
          <Box sx={styles?.subFooterBoxSx}>
            <img
              src={
                process.env.PUBLIC_URL + `/static/images/icons/community.svg`
              }
              alt="icon"
            />
            <Typography sx={styles?.footerTypoSx}>
              {buySearchCreditTexts?.footerTextFirst}
            </Typography>
          </Box>
        </Box>
        {/* Testimonials box */}
        <Box sx={styles?.subFooterBoxSx}>
          <img
            src={
              process.env.PUBLIC_URL + `/static/images/icons/testimonials.svg`
            }
            alt="icon"
          />
          <Typography sx={styles?.footerTypoSx}>
            {buySearchCreditTexts?.footerTextSecond}
          </Typography>
        </Box>
      </Box>
      <Box className="h-6"></Box>
    </Fragment>
  );
};
